import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=18347d6a&scoped=true&"
import script from "./uploads.vue?vue&type=script&lang=ts&"
export * from "./uploads.vue?vue&type=script&lang=ts&"
import style0 from "./uploads.vue?vue&type=style&index=0&id=18347d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18347d6a",
  null
  
)

export default component.exports